import { render, staticRenderFns } from "./CurrencyTooltip.vue?vue&type=template&id=057a2849"
import script from "./CurrencyTooltip.vue?vue&type=script&lang=js"
export * from "./CurrencyTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports